import { StyleSheet, Dimensions, Platform } from 'react-native'
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const { width } = Dimensions.get('screen')
const styles = StyleSheet.create({
  background: {
    flex: 1,
  },
  container: {
    flex: 1,
  },
  fillRemaining: {
    flexGrow: 1,
    paddingHorizontal: '10%'
  },
  headerContentWrapper: (top = 0) => {
    return {
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginTop: 24 + top,
      marginHorizontal: 16,
      paddingHorizontal: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? '10%' : "12"
    }
  },
  empty: {
    width: 24,
    height: 24,
  },
  closeIcon: (color = Colors.white) => {
    return {
      tintColor: color,
    }
  },
  caruselWrapper: {
    flexGrow: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  caruselContainer: {
    flexGrow: 1,
    maxHeight: 330,
    overflow: 'visible',
  },
  caruselContent: {
    maxHeight: 320,
    alignItems: 'center',
    overflow: 'visible',
  },
  paginationContainer: {
    paddingVertical: 0,
  },
  paginationDot: {
    width: 10,
    height: 10,
    borderRadius: 5,
    backgroundColor: Colors.white,
  },
  sectionTitle: {
    marginHorizontal: 16,
  },
  sectionGroup: {
    margin: 16,
  },
  button: {
    margin: 16,
  },
  shakeAnimContainer: {
    flexGrow: 1,
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  shakeAnimDesc: {
    marginHorizontal: 64,
  },
  inlineButtons: {
    flexDirection: 'row',
    margin: 16,
    minHeight: 128,
    alignItems: 'center',
  },
  leftButtonContentLoader: {
    marginRight: 16,
    borderRadius: 6,
    height: 43,
    width: (width - 48) / 2,
    backgroundColor: Colors.white,
  },
  leftButton: {
    width: (width - 48) / 2,
    marginRight: 16,
    borderRadius: 6,
  },
  rightButton: {
    flexGrow: 1,
  },
  // Modal non scrollable content
  modalContentContainerWraper: (bottom = 0, theme) => {
    return {
      flexGrow: 1,
      paddingHorizontal: 16,
      paddingVertical: 32,
      paddingBottom: bottom,
      backgroundColor: theme.colors.backgroundColor
    }
  },
  modalContentWraper: {
    flexGrow: 1,
    marginBottom: 32,
    justifyContent: 'space-evenly',
    alignItems: 'center',
  },
  verticalSpacing: {
    marginVertical: 16,
  },
  modalAnimIconContainer: {
    width: 120,
    height: 120,
    marginTop: 32,
  },
  modalAnimIcon: {
    flex: 1,
  },
  modalButton: {
    marginBottom: 16,
  },
  lastModalButton: {
    marginBottom: 32,
  },

  //special card images
  specialCardContainer: {
    position: 'relative',
    overflow: 'hidden',
  },
  topLeft: {
    position: 'absolute',
    top: -1,
    left: -1,
  },
  topRight: {
    position: 'absolute',
    top: -1,
    right: -1,
  },
  bottomLeft: {
    position: 'absolute',
    bottom: -1,
    left: -1,
  },
  bottomRight: {
    position: 'absolute',
    bottom: 0,
    right: 0,
  },

  //modal
  webView: {
    paddingBottom: 32,
  },
  detailsContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 16,
    paddingTop: 24,
  },
  lottieWrapper: {
    height: '100%',
    paddingHorizontal: 16,
    paddingVertical: 32,
    marginBottom: 32,
    justifyContent: 'center',
    alignItems: 'center',
  },
  lottie: {
    width: 150,
    height: 150,
    marginLeft: 0,
    alignSelf: 'center',
  },
})

const itemStyles = StyleSheet.create({
  cardContainer: {
    flexGrow: 1,
    backgroundColor: Colors.white,
    marginHorizontal: 16,
    marginBottom: 16,
    marginTop: 12,
    elevation: 8,
    shadowColor: Colors.black,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.16,
    shadowRadius: 8,
    borderRadius: 6,
    height: 288,
    overflow: 'visible',
  },
  card: {
    backgroundColor: Colors.white,
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
    width: '100%',
    padding: 30,
    borderRadius: 6,
  },
  quoteWrapper: {
    backgroundColor: Colors.white,
    position: 'relative',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexGrow: 1,
    width: Dimensions.get('screen').width > 700 ? (width - 300) * 0.8 : width - 32,
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 6,
  },
  quoteTouchable: {
    justifyContent: 'space-between',
    paddingVertical: 8,
  },
  animatedIcon: {
    width: 80,
    height: 80,
  },
  title: {
    marginTop: 24,
    marginBottom: 12,
  },
  quoteTopRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  shareContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  shareIcon: {
    tintColor: Colors.vfRed,
    marginLeft: 8,
  },
  quoteDesc: {
    marginHorizontal: 16,
    width: '100%'
  },
  rightQoute: {
    alignSelf: 'flex-end',
  },
})

export default styles
export { itemStyles }
